import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import UserMenu from '../UserMenu';

interface TraineeLayoutProps {
  children: ReactNode;
}

export default function TraineeLayout({ children }: TraineeLayoutProps) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const userName = user?.user_metadata?.full_name || user?.email || 'Trainee';
  const userRole = user?.user_metadata?.role || 'Trainee';

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="header-bar shadow-lg sticky top-0 z-10">
        <div className="max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 py-1.5">
          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <img
                src="/images/wingmentor-logo.png"
                alt="WingMentor Logo"
                className="h-10 w-auto opacity-90"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  const fallback = e.currentTarget.nextElementSibling as HTMLElement;
                  if (fallback) fallback.style.display = 'block';
                }}
              />
              <div style={{ display: 'none' }}>
                <h1 className="text-xl font-heading font-bold text-white">WingMentor</h1>
              </div>
            </div>
            <UserMenu
              userName={userName}
              userRole={userRole}
              onSignOut={handleSignOut}
              showSettings={false}
            />
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
